import { useTranslation } from 'react-i18next';

import * as St from './ConfirmationDialog.styles';

import { SidePanelSectionTabSt } from '~organisms/SidePanelSectionTab';

interface ConfirmationDialogProps {
  title?: string;
  visible?: boolean;
  content: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmationDialog = ({
  title,
  visible,
  content,
  onCancel,
  onConfirm,
}: ConfirmationDialogProps) => {
  const { t } = useTranslation();

  return (
    <SidePanelSectionTabSt.RemoveOptionModal
      open={visible}
      onCancel={onCancel}
      footer={
        <St.FooterContainer>
          <St.FooterButton onClick={onCancel}>{t('COMMON.NO')}</St.FooterButton>
          <St.FooterButton onClick={onConfirm}>
            {t('COMMON.YES')}
          </St.FooterButton>
        </St.FooterContainer>
      }
    >
      {title && (
        <SidePanelSectionTabSt.RemoveOptionModalTitle>
          {title}
        </SidePanelSectionTabSt.RemoveOptionModalTitle>
      )}

      <SidePanelSectionTabSt.RemoveOptionModalDescription>
        {content}
      </SidePanelSectionTabSt.RemoveOptionModalDescription>
    </SidePanelSectionTabSt.RemoveOptionModal>
  );
};

export default ConfirmationDialog;
